import React from "react";
import { render } from "react-dom";
import Points from "../widgets/points";

const widget = document.querySelector(".points-widget");
if (widget) render(<Points elem={widget} />, widget);
